/* Modules */
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import createSagaMiddleware from "redux-saga";
import { persistStore, persistReducer } from "redux-persist";
import { reducer as formReducer } from "redux-form";

/* Reducers */
import reducers from "../redux/reducers";

/* Sagas */
import rootSaga from "../redux/sagas";

/* Storage */
import storage from "redux-persist/lib/storage";

const initialState = {};
const sagaMiddleware = createSagaMiddleware();
const middlewares = [thunk, sagaMiddleware];

/* if (process.env.NODE_ENV === `development`) {
  const { logger } = require(`redux-logger`);

  middlewares.push(logger);
} */

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    ...reducers,
    form: formReducer,
  }),
  initialState
);

const current_location = window.location.href;

let not_use_redux_extension =
  (current_location.search("eprezto.com") ||
    current_location.search("dev.eprezto.com")) > 0
    ? true
    : false;

/* Force not use redux */
/* Comment the below line if you don't want use the extension in localhost  */
/* not_use_redux_extension = true; */

const store = not_use_redux_extension
  ? createStore(persistedReducer, compose(applyMiddleware(...middlewares)))
  : createStore(
      persistedReducer,
      compose(
        applyMiddleware(...middlewares),
        // window.__REDUX_DEVTOOLS_EXTENSION__()
      )
    );

let persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

store.asynReducers = {};
store.runSaga = sagaMiddleware.run;

// Make reducers hot reloadable, see http://mxs.is/googmo
/* istanbul ignore next */
if (module.hot) {
  module.hot.accept("../redux/reducers", () => {
    import("../redux/reducers").then((reducerModule) => {
      const createReducers = reducerModule.default;
      const nextReducers = createReducers(store.asyncReducers);

      store.replaceReducer(nextReducers);
    });
  });
}

export { store, persistor };
